<template lang="html">
    <section class="basket-list-items">
        <table class="table table-detail">
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                    <th>{{ $t("basket.labelPrice") }}</th>
                    <th>{{ $t("basket.labelQuantity") }}</th>
                    <th v-show="showUnit"></th>
                    <th v-show="showUnit">{{ $t("basket.labelUnit") }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colspan="6" class="table-items">
                        <BasketListItem v-for="itemBasket in datasListBaskets.items" :item="itemBasket" :key="itemBasket.id" :showUnit="showUnit">
                        </BasketListItem>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
import BasketListItem from './BasketListItem'

export default {
    name: 'basket-list',
    props: ['datasListBaskets'],
    data(){
        return {
            showUnit: false
        }
    },
    components: {BasketListItem},

    methods: {
        ...mapActions("basket/details", {
            updateBasket: "updateBasket",
            deleteBasketItemAction: "deleteBasketItemAction",
            placeOrder: "placeOrder"
        }),

    },
    computed: {
        ...mapGetters("basket/details", {
            getBasket: "getBasket"
        }),

    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.basket-list-items {
    & .table {
        &-detail {
            border-collapse: collapse;
            border-spacing: 0;
            border: 1px solid #005f7f;
            border-radius: 10px;
            overflow: hidden;
            .table-items {
                padding: 0;
            }
            & thead {
                & th {
                    color: #666666;
                    text-transform: uppercase;
                    font-size: 14px;
                    text-align: left;
                    font-weight: normal;
                    &:first-child {
                        width: 130px;
                    }
                    &:last-child {
                        width: 100px;
                    }
                    &:nth-child(2) {
                        width: 50%;
                    }
                    &:nth-child(3) {
                        width: 120px;
                    }
                    &:nth-child(4) {
                        width: 100px;
                    }
                    &:nth-child(5) {
                        width: 20px;
                    }
                }
            }
            & tbody {
                & tr {
                    transition: all 0.3s ease;
                    -o-transition: all 0.3s ease;
                    -webkit-transition: all 0.3s ease;
                    border-bottom: 1px solid #e5e5e5;
                    background-color: #ffffff;
                }
                & td {
                    border: none;
                    padding: 1.1rem;
                    text-align: left;
                    color: #6f6f6f;
                    & .btn-list {
                        color: #ffffff;
                        background: #005f7f;
                        padding: 5px 20px;
                        text-decoration: none;
                        &:hover {
                            background: #0085b2;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// BasketList.vue?7fafa639